import { render, staticRenderFns } from "./ShopGetConfig.vue?vue&type=template&id=145504d8&scoped=true&"
import script from "./ShopGetConfig.vue?vue&type=script&lang=js&"
export * from "./ShopGetConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShopGetConfig.vue?vue&type=style&index=0&id=145504d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145504d8",
  null
  
)

export default component.exports